import {DataStatus} from 'platform/components';

import {isNil} from 'ramda';
import {isNilOrEmpty} from 'ramda-adjunct';

import {useGetFieldDefinitionListQuery} from '@dms/api/settings';
import {EntityResourceIds} from '@dms/api/shared';
import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {EntityCustomFields, Main, usePermissions} from '@dms/shared';

import {useNavigate} from 'shared/web';

interface CustomFieldsProps {
  rentalOrderId: string | undefined;
}

export function CustomFields(props: CustomFieldsProps) {
  const navigate = useNavigate();

  const [canEditCustomFields] = usePermissions({
    permissionKeys: ['rentalOrderCustomFields'],
  });

  const {data: definitions, isLoading} = useGetFieldDefinitionListQuery(
    {resourceId: EntityResourceIds.rentalOrder, type: 'tenant'},
    {skip: isNil(props.rentalOrderId)}
  );

  if (isNil(props.rentalOrderId)) {
    return null;
  }

  return (
    <Main data-testid={testIds.rentalOrder.customFields('main')}>
      <DataStatus
        isLoading={isLoading}
        isEmpty={isNilOrEmpty(definitions)}
        spacing={5}
        minHeight={60}
        emptyMessage={i18n.t('page.generalSettings.labels.emptyCustomFieldsMessage')}
        action={{
          variant: 'link',
          title: i18n.t('page.generalSettings.labels.emptyCustomFieldsLink'),
          onClick: () => navigate(settingsRoutes.customFields),
        }}
        data-testid={testIds.rentalOrder.customFields('empty')}
      >
        <EntityCustomFields
          resourceId={EntityResourceIds.rentalOrder}
          recordId={props.rentalOrderId}
          isEditable={canEditCustomFields}
          data-testid={testIds.rentalOrder.customFields('card')}
        />
      </DataStatus>
    </Main>
  );
}
